import React from 'react';

import { TierDto } from 'legacy/events/types';
import { UserMe } from 'legacy/user/types';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

import { GoToStepFn } from '../types';
import Form from './Form';

type TierFormProps = {
  isTierPrivate: boolean;
  ticket?: TierDto;
  onRemove?: () => void;
  user: UserMe;
  submitForm: () => void;
  isEditing: boolean;
  goToStep: GoToStepFn;
  setIsDirty: (dirty: boolean) => void;
};

const modalTexts = {
  publicTier: {
    cta: 'Save public tier'
  },
  privateTier: {
    cta: 'Save private tier'
  }
};

const TierForm: React.FC<TierFormProps> = ({
  isTierPrivate,
  onRemove,
  ticket,
  user,
  isEditing,
  goToStep,
  submitForm,
  setIsDirty
}) => {
  const texts = modalTexts[isTierPrivate ? 'privateTier' : 'publicTier'];

  return (
    <>
      <div className="h-full pb-24 md:pb-16 overflow-auto max-h-[95vh] md:max-h-[600px]">
        <div className="p-4 pb-40">
          <Form
            user={user}
            ticket={ticket}
            isEditing={isEditing}
            goToStep={goToStep}
            setIsDirty={setIsDirty}
          />
        </div>
      </div>
      <div className="absolute left-0 bottom-0 border-t border-gray-200 w-full p-4 bg-white pb-12 md:pb-4">
        <div className="flex gap-3">
          {isEditing && (
            <Button
              type={ButtonType.Danger}
              onClick={onRemove}
              disabled={!(ticket && ticket.canDelete)}
            >
              Remove
            </Button>
          )}
          <Button type={ButtonType.Primary} onClick={submitForm}>
            {texts.cta}
          </Button>
        </div>
      </div>
    </>
  );
};

export default TierForm;
